import React, { useEffect, useState } from "react";
import {
  Bell,
  Mail,
  Info,
  IndianRupee,
  Loader2,
  CheckCircle2,
  AlertCircle,
} from "lucide-react";
import { setLowBalanceAlert } from "../../Services/profile/balanceAlert";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import { fetchProfile } from "../../Services/profile/profileservice";
import Seo from "../../Components/SeoComponent/Seo";
import Header from "../../Components/Header";

const LowBalanceAlert = () => {
  const [amount, setAmount] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // 'idle' | 'loading' | 'success' | 'failed'
    const [profileData, setProfileData] = useState(null);


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!amount) return showErrorToast("Please enter Amount");

    try {
      setStatus("loading");

      const res = await setLowBalanceAlert({
        alert_amount: amount,
        email,
      });

      if (res?.status?.code === 200) {
        showSuccessToast(res?.data?.message || res?.message);
        setStatus("success");
      } else {
        showErrorToast(res?.data?.message || res?.message);
        setStatus("failed");
      }
    } catch (error) {
      console.log(error);
    }

    // TODO: Replace this timeout with your actual API fetch logic
    // setTimeout(() => {
    //   // Simulating a random success or failure response
    //   setStatus(Math.random() > 0.3 ? 'success' : 'failed');

    //   // Reset status back to idle after 3 seconds
    //   setTimeout(() => setStatus('idle'), 3000);
    // }, 1500);
  };



    useEffect(() => {
    const loadProfile = async () => {
      try {
        const res = await fetchProfile();
        setProfileData(res?.data || null);
        if(res?.data?.email_address) {
            setEmail(res?.data?.email_address)
        }
      } catch (error) {
        console.error(error);
        showErrorToast("Failed to fetch profile");
      } 
    };

    loadProfile();
  }, []);

  return (
    <>
     <Seo />
          <Header heading={"Set Low Balance Alert"} />
     <div className="min-h-screen flex items-start justify-center relative overflow-hidden font-sans p-4">
      {/* Ambient Mesh Gradient Background Elements */}
      <div className="absolute top-[-10%] left-[-10%] w-[30rem] h-[30rem] bg-indigo-300/40 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-blob"></div>
      <div className="absolute top-[20%] right-[-10%] w-[30rem] h-[30rem] bg-cyan-300/40 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-blob animation-delay-2000"></div>
      <div className="absolute bottom-[-20%] left-[20%] w-[30rem] h-[30rem] bg-fuchsia-300/40 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-blob animation-delay-4000"></div>

      {/* Main Glassmorphism Card */}
      <div className="relative w-full max-w-xl bg-white/40 backdrop-blur-2xl border border-white/60 rounded-[2.5rem] shadow-[0_8px_40px_0_rgba(31,38,135,0.07)] p-4 z-10">
        {/* Header Icon & Title */}
        <div className="flex flex-col items-center mb-8 text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-2xl flex items-center justify-center shadow-[0_10px_20px_-10px_rgba(99,102,241,0.8)] mb-5 transform rotate-3 transition-transform hover:rotate-6">
            <Bell
              className="w-7 h-7 text-white transform -rotate-3"
              strokeWidth={2.5}
            />
          </div>
          <h2 className="text-3xl font-extrabold text-slate-800 tracking-tight">
            Set Alert
          </h2>
          <p className="text-slate-500 mt-2 font-medium text-sm">
            We'll notify you instantly
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Instruction Box */}
          <div className="flex items-start gap-3 p-4 bg-indigo-50/50 border border-indigo-100/60 rounded-2xl backdrop-blur-md shadow-sm">
            <Info className="w-5 h-5 text-indigo-500 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-slate-600 leading-relaxed font-medium">
              The alert will be sent to your{" "}
              <span className="text-indigo-900 font-bold">
                registered email
              </span>
              . If you want to use a new email, you can enter it below.
            </p>
          </div>

          {/* Alert Amount Input (Mandatory) */}
          <div className="space-y-2 group">
            <label
              htmlFor="amount"
              className="block text-sm font-bold text-slate-700 ml-1"
            >
              Alert Amount <span className="text-rose-500">*</span>
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-slate-400 transition-colors group-focus-within:text-indigo-600">
                <IndianRupee className="w-5 h-5 text-slate-800" />
              </div>
              <input
                type="number"
                id="amount"
                required
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="0.00"
                className="w-full pl-11 pr-4 py-3.5 bg-white/60 border border-white/80 focus:border-indigo-300 rounded-2xl outline-none focus:ring-4 focus:ring-indigo-500/10 transition-all shadow-[inset_0_2px_5px_rgba(0,0,0,0.02)] backdrop-blur-md text-slate-800 font-bold text-lg placeholder:text-slate-400 placeholder:font-medium"
              />
            </div>
          </div>

          {/* Alternate Email Input (Optional) */}
          <div className="space-y-2 group">
            <label
              htmlFor="email"
              className="block text-sm font-bold text-slate-700 ml-1"
            >
              Custom Email{" "}
              <span className="text-slate-400 font-medium text-xs ml-1">
                (Optional)
              </span>
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-slate-500 transition-colors group-focus-within:text-indigo-600">
                <Mail className="w-5 h-5" />
              </div>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter new email address"
                className="w-full pl-11 pr-4 py-3.5 bg-white/60 border border-white/80 focus:border-indigo-300 rounded-2xl outline-none focus:ring-4 focus:ring-indigo-500/10 transition-all shadow-[inset_0_2px_5px_rgba(0,0,0,0.02)] backdrop-blur-md text-slate-800 font-medium placeholder:text-slate-400"
              />
            </div>
          </div>

          {/* Dynamic API Response Messages */}
          <div className="min-h-[44px]">
            {status === "success" && (
              <div className="flex items-center justify-center gap-2 text-emerald-700 bg-emerald-50/80 border border-emerald-200/60 py-2.5 px-4 rounded-xl backdrop-blur-md shadow-sm animate-in fade-in slide-in-from-bottom-2 duration-300">
                <CheckCircle2 className="w-5 h-5" />
                <span className="text-sm font-bold">
                  Alert configured successfully!
                </span>
              </div>
            )}

            {status === "failed" && (
              <div className="flex items-center justify-center gap-2 text-rose-700 bg-rose-50/80 border border-rose-200/60 py-2.5 px-4 rounded-xl backdrop-blur-md shadow-sm animate-in fade-in slide-in-from-bottom-2 duration-300">
                <AlertCircle className="w-5 h-5" />
                <span className="text-sm font-bold">
                  Failed to set alert. Please try again.
                </span>
              </div>
            )}
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={status === "loading"}
            className="w-full relative group overflow-hidden rounded-2xl disabled:opacity-70 disabled:cursor-not-allowed"
          >
            <div className="relative flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-4 px-8 rounded-2xl font-extrabold text-[15px] shadow-[0_8px_20px_-8px_rgba(99,102,241,0.6)] transition-all group-hover:shadow-[0_10px_25px_-8px_rgba(99,102,241,0.8)] active:scale-[0.98]">
              {status === "loading" ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  Processing...
                </>
              ) : (
                "Set Alert"
              )}
            </div>
          </button>
        </form>
      </div>

      {/* Custom CSS for blob animation (Add to your global CSS or Tailwind config if you want the mesh background to move) */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `,
        }}
      />
    </div>
    </>
   
  );
};

export default LowBalanceAlert;
